import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class IncomeMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.income.mapperError"));

        Object.setPrototypeOf(this, IncomeMapperError.prototype);
    }
}